export const RAISED_BUTTON = 'RAISED_BUTTON';
export const OUTLINED_BUTTON = 'OUTLINED_BUTTON';
export const TEXT_BUTTON = 'TEXT_BUTTON';
export const FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON';
export const ICON_BUTTON = 'ICON_BUTTON';
export const CSV_DOWNLOAD_BUTTON = 'CSV_DOWNLOAD_BUTTON';
